<template>
  <div>
    <div class="solicitationDetails" v-if="isShelves">
      <Left :detailsData="detailsData" />
      <center :detailsData="detailsData" />
      <Right
        :periodiID="periodiID"
        :wenxian="wenxian"
        :periodicalInfo="periodicalInfo"
        :periodicalId="periodicalId"
        :detailsData="detailsData"
      />
    </div>
    <div class="solicitationDetails" v-else>
      <Shelves />
    </div>
  </div>
</template>

<script>
import Left from "../components/left";
import Center from "./components/center";
import Right from "./components/right";
import Shelves from "../components/shelves";
import {changeTitle, changeKeywords, changeDescription} from "@/utils/brower.js";
export default {
  name: "index",
  components: {
    Left,
    Center,
    Right,
    Shelves
  },
  created() {
    this.getDetails();
  },
  data() {
    return {
      isShelves: true,
      detailsData: {},
      wenxian: [],
      // autherInfo: {},
      // autherList: {},
      periodicalId: {},
      periodiID: {},
      periodicalInfo: {},
    };
  },
  methods: {
    async getDetails() {
      let res = await this.$apis.recomendServe.solicitation({
        id: this.$router.history.current.query.id,
      });
      if (res.resultCode === '200') {
        this.detailsData = res.data;
        sessionStorage.setItem('perId',this.detailsData.perId)
        changeTitle(this.$global.matchReg(this.detailsData.title))
        changeKeywords(this.detailsData.keyword)
        changeDescription(this.$global.matchReg(this.detailsData.summary))
        await this.getwenxian();
        await this.Getperiodical();
        await this.getperiodiID();
      } else if (res.resultCode === "10401002" || res.resultCode === "10401001") {
        this.isShelves = false
      }
    },
    async Getperiodical() {
      let obj = {
        type: 1,
        companyId: this.detailsData.perId,
      };
      const res = await this.$apis.recomendServe.getAuthor(obj);
      this.periodicalInfo = res.content;
      this.detailsData.img = res.content.headImg
      console.log(this.periodicalInfo, " this.periodicalInfo");
    },
    async getperiodiID() {
      let obj = {
        periodicalId: this.detailsData.perId,
      };
      console.log(obj, "getperiodiIDObj");
      const res = await this.$apis.recomendServe.periodiID(obj);
      this.periodiID = res.data;
      console.log(this.periodiID, " this.periodiID");
    },

    async getwenxian() {
      const { data } = await this.$apis.recomendServe.getwenxian({
        companyId: this.detailsData.perId,
        pageNo: 1,
        pageSize: 5,
      });
      try {
        this.wenxian = data.list;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.solicitationDetails {
  width: 1300px;
  display: flex;
}
</style>
